import { Drawer } from "antd";
import { useMemo } from "react";
import { getUserForm } from '../config';
import { Styles } from "../../locations/create";
import DynamicForm from "../../../DynamicFormNew";
import { DrawerHeader } from "datastake-daf/dist/components";
import { CREATE_DRAWER_WIDTH } from "../../../../helpers/form";

const showSaveAndNext = false;
const activeFormIndex = 0;

export default function CreateUserDrawer({
  t = (s) => s,
  createVisible,
  onInvite = () => { },
  mod = 'pme',
  onClose = () => { },
  userToEdit,
  userRoles = [],
}) {
  const disabledInputs = useMemo(() => !userToEdit ? [] : ['firstName', 'lastName', 'email'], [userToEdit]);
  const data = useMemo(() => ({ ...(userToEdit || {}), userRole: userToEdit?.role }), [userToEdit]);
  const form = useMemo(() => getUserForm({ t, userRoles }), [t, userRoles]);

  return (
    <Drawer
      open={createVisible}
      onClose={() => onClose()}
      destroyOnClose={true}
      title={<DrawerHeader title={t(!!userToEdit ? 'Edit User' : 'New User')} />}
      maskClosable={false}
      width={CREATE_DRAWER_WIDTH}
      bodyStyle={{ padding: 0 }}
    >
      <Styles>
        {createVisible ? (
          <DynamicForm
            showSaveAndNext={showSaveAndNext}
            form={form}
            data={data}
            activeFormIndex={activeFormIndex}
            onCancel={() => onClose()}
            module={mod}
            disabledInputs={disabledInputs}
            submit={(payload) => {
              if (mod === 'pme' || mod === 'cadd') {
                onInvite({
                  ...payload,
                  apps: {
                    mmt: { ...(userToEdit?.apps?.mmt || {}), role: payload.role },
                  },
                });
                return;
              }

              onInvite({
                ...payload,
                apps: {
                  [mod]: { ...((userToEdit?.apps || {})[mod] || {}), role: payload.role }
                }
              });
            }}
          />
        ) : null}
      </Styles>
    </Drawer>
  )
}
